import { useState, useEffect } from 'react';

import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { LookupAction } from 'src/actions/lookup.action';
import { LstracuuAction } from 'src/actions/lstracuu.action';

import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  MenuItem,
  Select as Select1,
  InputAdornment,
  SvgIcon,
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';

import { AppAction } from '../../actions/app.action';

import numeral from 'numeral';

import { showToast } from 'src/utils/common';

import { NOTI_TYPES } from 'src/utils/constants';
import { MobidanhsachdonAction } from 'src/actions/mobidanhsachdon.action';

const MobifoneNapDonDetail = (props) => {

  const dispatch = useDispatch()
  const { balance } = useSelector(state => state.lookup)
  const { leaders, brands, info, role } = useSelector(state => state.profile)

  const [chietKhauCuaBan, setChietKhauCuaBan] = useState({
      chiet_khau_smart_vi: "0",
      chiet_khau_tkc: "0",
      chiet_khau_dichvu: "0",
      chiet_khau_bunca: "0",
      chiet_khau_napho: "0"
  });

  useEffect(() => {
    async function fetchData() {
        if (info && info.cai_dat_chiet_khau) {
            try {
                const jsonObject = JSON.parse(info.cai_dat_chiet_khau);
                setChietKhauCuaBan({
                    ...values,
                    chiet_khau_smart_vi: typeof jsonObject.chiet_khau_smart_vi !== 'undefined' ? jsonObject.chiet_khau_smart_vi : '0',
                    chiet_khau_tkc: typeof jsonObject.chiet_khau_tkc !== 'undefined' ? jsonObject.chiet_khau_tkc : '0',
                    chiet_khau_dichvu: typeof jsonObject.chiet_khau_dichvu !== 'undefined' ? jsonObject.chiet_khau_dichvu : '0',
                    chiet_khau_bunca: typeof jsonObject.chiet_khau_bunca !== 'undefined' ? jsonObject.chiet_khau_bunca : '0',
                    chiet_khau_napho: typeof jsonObject.chiet_khau_napho !== 'undefined' ? jsonObject.chiet_khau_napho : '0'
                });
            } catch (error) {
                console.log(error);
            }
        }
    }
    fetchData();
  }, [])
  
  const [values, setValues] = useState({
    number_type: '-99',
    operator: '-99',
    ten_don: '',
    nha_mang: '-99',
    boi_so: '-99',
    chi_tiet_don: '',
    outputChiTietDon: [],
    error: false,
  });

  const handleChange = (event) => {
    if (event.target.name == 'number_type' && event.target.value != '1' && values.nha_mang == 'tkc') {
      setValues({
        ...values,
        [event.target.name]: event.target.value,
        'number_type': '1',
      });
    } else if (event.target.name == 'nha_mang' && event.target.value == 'tkc') {
      setValues({
        ...values,
        [event.target.name]: event.target.value,
        'number_type': '1',
      });
    } else {
      setValues({
        ...values,
        [event.target.name]: event.target.value,
      });
    }
  };

  const handleBlur = (event) => {
    let outputChiTietDon = [];

    if (event.target.name == 'chi_tiet_don') {
      let outputCtd = '';
      let ctd = event.target.value
      ctd = ctd.split(/\n/g);
      if (ctd)
      {
        for (let i = 0; i < ctd.length; i++) {
          let napTheoSo = ctd[i].split(/[\s,]+/);
          if (napTheoSo && ctd[i].trim() != '') {
            let thue_bao = napTheoSo[0].replace(/\D/g, '');
            if (napTheoSo.length == 2) {
              let so_tien = napTheoSo[napTheoSo.length - 1].replace(/\D/g, '');

              if (values.nha_mang != 'tkc' && so_tien % 10000 != 0) {
                setValues({
                  ...values,
                  error: true,
                });
                showToast(NOTI_TYPES.ERROR, `Dòng thứ ${i + 1} (${thue_bao}) số tiền không phải là bội số của 10.000`)
                return;
              }

              if (values.nha_mang == 'tkc' && so_tien < 1000) {
                setValues({
                  ...values,
                  error: true,
                });
                showToast(NOTI_TYPES.ERROR, `Dòng thứ ${i + 1} (${thue_bao}) số tiền nạp phải >= 1.000`)
                return;
              }

              if (values.nha_mang == 'smart_vi' && so_tien < 20000) {
                setValues({
                  ...values,
                  error: true,
                });
                showToast(NOTI_TYPES.ERROR, `Dòng thứ ${i + 1} (${thue_bao}) số tiền nạp phải >= 20.000`)
                return;
              }

              outputCtd += `${thue_bao},${so_tien}`;
              if (i < ctd.length - 1) outputCtd += '\n'
              outputChiTietDon.push({thue_bao: thue_bao.slice(-9), so_tien});
            } else {
              setValues({
                ...values,
                error: true,
              });
              showToast(NOTI_TYPES.ERROR, `Dòng thứ ${i + 1} (${thue_bao}) nhập sai cấu trúc, dấu phẩy hoặc khoảng trắng đặt sai vị trí`)
              return;
            }
          }
        }
      }
      event.target.value = outputCtd;
    }
    setValues({
      ...values,
      [event.target.name]: event.target.value,
      outputChiTietDon,
      error: false,
    });
  };

  const onLookup = async () => {
    let payload = values

    if (payload.number_type == '-99') {
      showToast(NOTI_TYPES.ERROR, 'Bạn phải chọn loại thuê bao')
      return;
    }

    if (payload.operator == '-99') {
      showToast(NOTI_TYPES.ERROR, 'Bạn phải chọn nhà mạng')
      return;
    }

    if (payload.ten_don == '') {
      showToast(NOTI_TYPES.ERROR, 'Bạn phải nhập tên đơn')
      return;
    }

    if (payload.nha_mang == '-99') {
      showToast(NOTI_TYPES.ERROR, 'Bạn phải chọn nhà mạng nạp')
      return;
    }

    // if (payload.nha_mang != 'tkc' && payload.boi_so == '-99') {
    //   showToast(NOTI_TYPES.ERROR, 'Bạn phải chọn bội số')
    //   return;
    // }
    
    if (!payload.error) {
      if (payload.outputChiTietDon.length == 0) {
        showToast(NOTI_TYPES.ERROR, 'Bạn phải nhập chi tiết đơn')
        return;
      }

      console.log(payload)

      try {
        const result = await dispatch(MobidanhsachdonAction.create({ number_type: payload.number_type, operator: payload.operator, loai_don: 'nap_don', ten_don: payload.ten_don, nha_mang: payload.nha_mang, boi_so: payload.boi_so, chi_tiet_don: payload.outputChiTietDon }));
        
        // if (result && result.result == 'success') showToast(NOTI_TYPES.SUCCESS, 'Tạo đơn thành công!');
        // else {
        //   let errorMes = `Tạo đơn thất bại!`;
        //   if (typeof result.msg !== 'undefined') errorMes = result.msg;
        //   showToast(NOTI_TYPES.ERROR, errorMes);
        // }
        
        if (result && result.ket_qua_nap_nhieu_so && result.ket_qua_nap_nhieu_so.length > 0) {
          let res = ''

          for (let i = 0; i < result.ket_qua_nap_nhieu_so.length; i++) {
            res += `- ${result.ket_qua_nap_nhieu_so[i].thue_bao}: ${result.ket_qua_nap_nhieu_so[i].ket_qua.result == 'success' ? 'THÀNH CÔNG' : 'THẤT BẠI'} - ${result.ket_qua_nap_nhieu_so[i].ket_qua.msg} (${result.ket_qua_nap_nhieu_so[i].ket_qua.code})\n`
          }

          alert(res);
        }
      } catch (error) {
        let errorMes = `Tạo đơn thất bại!`;
        if (typeof error.msg !== 'undefined') errorMes = error.msg;
        showToast(NOTI_TYPES.ERROR, errorMes);
      }
    }
  }

  return (
    <form {...props}>
      <Card>
        <CardHeader
          title="NẠP ĐƠN"
        />
        <Divider />
        <CardContent>
          <Box
            style={{marginBottom: '25px'}}
          >
            <span style={{color: 'blue'}}>* Chiết khấu của bạn:</span>
            <br></br>
            <span style={{color: 'green'}}>- TOP-UP: <span style={{color: 'brown'}}>{chietKhauCuaBan.chiet_khau_smart_vi}%</span></span>
            <br></br>
            <span style={{color: 'green'}}>- TKC: <span style={{color: 'brown'}}>{chietKhauCuaBan.chiet_khau_tkc}%</span></span>
            <br></br>
            {role.priority < 3 && <>
                <span style={{color: 'green'}}>- DV: <span style={{color: 'brown'}}>{chietKhauCuaBan.chiet_khau_dichvu}%</span></span>
                <br></br>
                <span style={{color: 'green'}}>- BC: <span style={{color: 'brown'}}>{chietKhauCuaBan.chiet_khau_bunca}%</span></span>
                <br></br>
            </>}
            <span style={{color: 'green'}}>- Nạp hộ Mobifone: <span style={{color: 'brown'}}>{chietKhauCuaBan.chiet_khau_napho}%</span></span>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <TextField
              fullWidth
              label="Tên đơn"
              margin="normal"
              name="ten_don"
              onChange={handleChange}
              required
              value={values.ten_don}
              variant="outlined"
              style={{ height: 56, marginTop: 0, width: "100%", marginLeft: 0 }}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <Select1
              style={{ height: 56, marginTop: 6, marginBottom: 6, width: "100%", marginLeft: 0 }}
              name="operator"
              value={values.operator || -99}
              onChange={handleChange}
              variant="outlined"
              startAdornment={(
                <InputAdornment position="start">
                  <SvgIcon fontSize="small" color="action">
                    <SearchIcon />
                  </SvgIcon>
                </InputAdornment>
              )}
            >
              <MenuItem value="-99">Nhà mạng...</MenuItem>
              <MenuItem value="MOBIFONE">MOBIFONE</MenuItem>
              <MenuItem value="VINAPHONE">VINAPHONE</MenuItem>
              <MenuItem value="VIETTEL">VIETTEL</MenuItem>
            </Select1>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <Select1
              style={{ height: 56, marginTop: 6, marginBottom: 6, width: "100%", marginLeft: 0 }}
              name="nha_mang"
              value={values.nha_mang || -99}
              onChange={handleChange}
              variant="outlined"
              startAdornment={(
                <InputAdornment position="start">
                  <SvgIcon fontSize="small" color="action">
                    <SearchIcon />
                  </SvgIcon>
                </InputAdornment>
              )}
            >
              <MenuItem value="-99">Nhà mạng nạp...</MenuItem>
              <MenuItem value="smart_vi">TOP-UP</MenuItem>
              <MenuItem value="tkc">TKC</MenuItem>
              {role.priority < 3 && <MenuItem value="dichvu">DV</MenuItem>}
              {role.priority < 3 && <MenuItem value="bunca">BC</MenuItem>}
              <MenuItem value="napho">Nạp hộ Mobifone</MenuItem>
              {/* <MenuItem value="mobifone_gsm">Mobifone GSM</MenuItem>
              <MenuItem value="mobifone_otp">Mobifone (Nhập OTP)</MenuItem> */}
            </Select1>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <Select1
              style={{ height: 56, marginTop: 6, marginBottom: 6, width: "100%", marginLeft: 0 }}
              name="number_type"
              value={values.number_type || -99}
              onChange={handleChange}
              variant="outlined"
              startAdornment={(
                <InputAdornment position="start">
                  <SvgIcon fontSize="small" color="action">
                    <SearchIcon />
                  </SvgIcon>
                </InputAdornment>
              )}
            >
              <MenuItem value="-99">Loại thuê bao...</MenuItem>
              <MenuItem value="1">TRẢ TRƯỚC</MenuItem>
              <MenuItem value="2">TRẢ SAU</MenuItem>
            </Select1>
          </Box>
          {/* <Box
            sx={{
              display: values.nha_mang == 'tkc' ? 'none' : 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <Select1
              style={{ height: 56, marginTop: 6, marginBottom: 6, width: "100%", marginLeft: 0 }}
              name="boi_so"
              value={values.boi_so || -99}
              onChange={handleChange}
              variant="outlined"
              startAdornment={(
                <InputAdornment position="start">
                  <SvgIcon fontSize="small" color="action">
                    <SearchIcon />
                  </SvgIcon>
                </InputAdornment>
              )}
            >
              <MenuItem value="-99">Chọn bội...</MenuItem>
              <MenuItem value="menh_gia_bat_ky">Mệnh giá bất kỳ</MenuItem>
              <MenuItem value="10000">10.000</MenuItem>
              <MenuItem value="20000">20.000</MenuItem>
              <MenuItem value="the_nho_nho_hon_50000">{"Thẻ nhỏ (<50k)"}</MenuItem>
              <MenuItem value="50000">50.000</MenuItem>
              <MenuItem value="100000">100.000</MenuItem>
              <MenuItem value="200000">200.000</MenuItem>
              <MenuItem value="300000">300.000</MenuItem>
              <MenuItem value="500000">500.000</MenuItem>
              <MenuItem value="1000000">1.000.000</MenuItem>
            </Select1>
          </Box> */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <div style={{ marginTop: 6, width: "100%", marginLeft: 0 }}>
              <textarea
                rows="10"
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="901111111,100000"
                value={values.chi_tiet_don}
                name='chi_tiet_don'
                style={{fontSize: 18, padding: 6, width: '100%'}}
              ></textarea>
            </div>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <Button
              color="primary"
              variant="contained"
              disabled=""
              onClick={onLookup}
              style={{ height: 56, marginTop: 6, width: '100%', marginLeft: 0 }}
            >
              NẠP
            </Button>
          </Box>
        </CardContent>
        <Divider />
      </Card>
    </form>
  );
};

export default MobifoneNapDonDetail;
